import React from "react";
import { toast } from "react-toastify";
import { approveRequest } from "../../services/user/api";
import "../../styles/user/requestActionModal.css";

const ApproveRequestPage = ({
  request,
  isOpen,
  onClose,
  onApproved,
  processing,
  setProcessing,
  formatRequestType,
}) => {
  if (!isOpen || !request) {
    return null;
  }

  const handleApprove = async () => {

const userId = Number(
  request?.userId ??
  request?.notificationId,
);

const requestId = Number(
  request?.requestId ??
  request?.redirectUrl
  
);
    if (
  !Number.isFinite(userId) ||
  !Number.isFinite(requestId)
) {
  toast.error(
    "Notification ID or Request ID is missing."
  );
  return;
}

    const updateRequest = {
  userId,
  requestId,
};
    try {
      setProcessing(true);

      const response = await approveRequest(updateRequest);

      toast.success(
        response?.data?.message ||
          "Request approved successfully.",
      );

      onApproved(request);
      // onClose();
    } catch (error) {
      console.error(
        "Approve request error:",
        error?.response?.data || error,
      );

      toast.error(
        error?.response?.data?.message ||
          "Failed to approve request.",
      );
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="request-action-modal">
        <h3>Approve Request</h3>

        <p>
          Are you sure you want to approve the{" "}
          <strong>
            {formatRequestType(
              request?.requestType ?? request?.title,
            )}
          </strong>{" "}
          request?
        </p>

        <div className="modal-actions">
          <button
            type="button"
            className="modal-btn cancel"
            disabled={processing}
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="button"
            className="modal-btn confirm"
            disabled={processing}
            onClick={handleApprove}
          >
            {processing ? "Approving..." : "Approve"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApproveRequestPage;